export const MODAL_STATE_COMMENT = 'COMMENT';
export const MODAL_STATE_SUMMARY = 'SUMMARY';
